import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface ExternalLinkCleanerOptions {
  trackingParams?: string[];
  /** Hostname do portal. Default: hostname de `environment.domain`. */
  appDomain?: string;
  /** Modo restritivo: limpa apenas destinos nesta lista. */
  excludeDomains?: string[];
}

export interface ExternalLinkCleanerConfig {
  trackingParams: string[];
  appDomain: string;
  excludeDomains: string[];
}

export const DEFAULT_EXTERNAL_LINK_TRACKING_PARAMS = [
  '_gl',
  '_ga',
  '_ga_*',
  'utm_*'
] as const;

export function resolveAppDomain(domain?: string): string {
  if (domain) {
    return domain.toLowerCase();
  }

  try {
    return new URL(environment.domain).hostname.toLowerCase();
  } catch {
    return '';
  }
}

export const EXTERNAL_LINK_CLEANER_CONFIG =
  new InjectionToken<ExternalLinkCleanerConfig>(
    'EXTERNAL_LINK_CLEANER_CONFIG',
    {
      providedIn: 'root',
      factory: () => ({
        trackingParams: [...DEFAULT_EXTERNAL_LINK_TRACKING_PARAMS],
        appDomain: resolveAppDomain(),
        excludeDomains: []
      })
    }
  );
